function useUserReactList(emoticon, reactions) {
  return reactions.filter(({ type }) => type === emoticon).map(({ accountUser }) => accountUser.fullName);
}

export default useUserReactList;